import React from 'react'
import { useTranslation } from 'react-i18next'
import { Route, useNavigate } from 'react-router-dom'
import { Stack, Typography, useTheme } from '@mui/material'

import Logout from './Logout'
import Fake, { FakeOut, ExitModeDemo } from './Fake'
import Confirmation from './Confirmation'
import DirectorySSO from './DirectorySSO'
import DirectoryCenter from './DirectoryCenter'
import DisclaimerBetaOnly from './DisclaimerBetaOnly'

import RecoveryPasswordPage from './Login/pages/RecoveryPasswordPage'
import LoginPage from './Login/pages/LoginPage'
import Me from './Me'
import HyperisSSO from './HyperisSSO'
import TwoFaCodeValidation, { Disclaimer as TwoFaDisclaimer } from './Login/pages/2FA/'
import AuthBasePageWrapper from './Login/AuthBasePageWrapper'
import LoginPaper from './Login/components/LoginPaper'
import { 
  SponsorCodeConfirmation, 
  SponsorCodeGenerator, 
  SponsorErrorPage
} from './Sponsor'
import IdentityProvider from './IdentityProvider'
import ExternalApp from './ExternalApp'

const WrapperCodeValidation = () => {
  const theme = useTheme()
  const {t} = useTranslation()
  const hasTwoActivated = localStorage.getItem('TWO_FA_ACTIVATED') === '1'
  return (
    <AuthBasePageWrapper
      footer={
        !hasTwoActivated ? (
          <Stack direction={'row'} gap={0.5} alignItems={'center'} mt={4} sx={{ color: '#656565' }}>
            <Typography sx={{ fontSize: 14 }} component={'span'}>
              {t('two_fa_code_sent.footer')}
            </Typography>
            <Typography
              sx={{
                fontSize: 14,
                color: theme.palette.primary.main,
                cursor: 'pointer'
              }}
              component={'span'}
              onClick={() => {
                window.location.href = '/auth/me'
              }}>
              Dashboard.
            </Typography>
          </Stack>
        ) : null
      }>
      <LoginPaper>
        <TwoFaCodeValidation
          onValid={() => {
            window.location.href = '/auth/me'
          }} />
      </LoginPaper>
    </AuthBasePageWrapper>
  )
}

const WrapperDisclaimer = () => {
  const navigate = useNavigate()

  return (
    <AuthBasePageWrapper>
      <LoginPaper>
        <TwoFaDisclaimer
          onSubmit={() => navigate('/auth/two_fa_code_validation')}
          onCancel={() => {
            window.location.href = '/auth/me'
          }}
        />
      </LoginPaper>
    </AuthBasePageWrapper>
  )
}

const authRoutes = () => [
    <Route path={'auth'} key="auth-root">
      <Route path={'me'} element={<Me />} />
      <Route path={'login'} key={'admin-login'} element={<LoginPage />} />
      <Route path={'logout'} key={'admin-logout'} element={<Logout />} />
      <Route path={'directory_sso'} element={<DirectorySSO />} />
      <Route path={'directory_center/:token'} element={<DirectoryCenter />} />
      <Route path={'fakeout'} key={'admin-fakeout'} element={<FakeOut />} />
      <Route path={'exit_demo_mode'} key={'admin-exit-demo-mode'} element={<ExitModeDemo />} />
      <Route path={'fake'} key={'admin-fake'} element={<Fake />} />
      <Route path={'hyperis_sso'} element={<HyperisSSO />}/>
      <Route path={'disclaimer-beta-only'} element={<DisclaimerBetaOnly />} />
      <Route path={'redirect-external-app'} element={<ExternalApp />} />
      <Route
        path={'two_fa_code_validation'}
        element={<WrapperCodeValidation />}
      />
      <Route path={'two_fa_disclaimer'} element={<WrapperDisclaimer />}/>
      <Route
        path={'password/recovery'}
        key={'admin-recovery'}
        element={<RecoveryPasswordPage />}
      />
      <Route
        path={'password/recovery/:token'}
        key={'admin-recovery-password'}
        element={<RecoveryPasswordPage />}
      />
      <Route
        path={'confirmation/:token'}
        key={'admin-confirmation'}
        element={<Confirmation />}
      />
      <Route
        path={'sponsor/:token'}
        key={'admin-sponsor'}
        element={<SponsorCodeGenerator />}
      />
      <Route
        path={'sponsor/:token/confirm'}
        key={'admin-sponsor-confirmation'}
        element={<SponsorCodeConfirmation />}
      />
    </Route>,
    
    <Route path={'sponsor/:token'} key={'sponsor'} element={<SponsorCodeGenerator />} />,
    <Route path={'sponsor/:token/confirm'} key={'sponsor-confirmation'} element={<SponsorCodeConfirmation />} />,
    <Route path={'errors/:errorCode'} key={'sponsor-errors'} element={<SponsorErrorPage />} />,
    <Route path={'account/identity_provider'} element={<IdentityProvider />} />
]

export default authRoutes
